"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Generate = exports.FullScreenIcon = exports.ErrorLonger = exports.Marker = exports.CodeContainer = exports.Editor = void 0;
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../Colors");
const vars = __importStar(require("../../../vars"));
const animationName = typestyle_1.keyframes({
    ['0%']: {
        transform: `rotate(0deg)`,
    },
    ['100%']: {
        transform: `rotate(360deg)`,
    },
});
exports.Editor = typestyle_1.style({
    flex: 1,
});
exports.CodeContainer = typestyle_1.style({
    flex: 1,
    overflowY: 'hidden',
    overflowX: 'hidden',
    display: 'flex',
    flexFlow: 'column',
});
exports.Marker = typestyle_1.style({
    background: 'red',
});
exports.ErrorLonger = typestyle_1.style({
    position: 'absolute',
    background: Colors_1.Colors.red[0],
    color: Colors_1.Colors.grey[0],
    padding: 10,
    fontSize: 10,
    maxWidth: 200,
    margin: 5,
    borderRadius: 5,
    right: 0,
    letterSpacing: 1,
    zIndex: 3,
});
exports.FullScreenIcon = typestyle_1.style({
    cursor: 'pointer',
    display: 'flex',
    color: Colors_1.Colors.grey[0],
    transition: vars.transition,
    padding: `0 10px`,
    $nest: {
        '&:hover,&.active': {
            color: Colors_1.Colors.green[0],
        },
    },
});
exports.Generate = typestyle_1.style({
    marginLeft: 'auto',
    color: Colors_1.Colors.green[3],
    padding: `2px 6px`,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: 10,
    textTransform: 'lowercase',
    borderRadius: 3,
    fontWeight: 'bold',
    transition: vars.transition,
    $nest: {
        '&.disabled': {
            color: Colors_1.Colors.grey[6],
        },
        '&.ready': {
            color: Colors_1.Colors.grey[0],
            $nest: {
                '&:hover': {
                    color: Colors_1.Colors.green[0],
                    $nest: {
                        svg: {
                            animationName,
                            animationDuration: '1s',
                            animationIterationCount: 'infinite',
                            animationTimingFunction: 'linear',
                        },
                    },
                },
            },
        },
    },
});
typestyle_1.cssRaw(`
.monacoError{
  background:${Colors_1.Colors.red[0]}33
}
.monacoMarginError{
  background:${Colors_1.Colors.red[0]};
  border-radius:50%;
  margin-left:5px;
  width:12px !important;
  height:12px !important;
}
.monaco-editor .monaco-editor-hover {
  border: 1px solid 
  #454545;
  padding: 4px 8px;
  font-size: 12px;
}
.monaco-editor-hover .hover-contents {
  padding: 0px;
}
`);
